import { nonUndefined } from "Utility";
import { FsTimeAttackRoundWeighting } from "db/model/match/Set/TimeAttack/Scoring/FsTimeAttackRoundWeighting";
import {
  TimeAttackRoundWeighting,
  isTimeAttackRoundWeightingOrder,
} from "model/Match/Set/TimeAttack/Track/Scoring/TimeAttackRoundWeighting";

export const mapTimeAttackRoundWeightings = (
  fsModels: FsTimeAttackRoundWeighting[]
) => {
  return nonUndefined(fsModels.map(mapTimeAttackRoundWeighting));
};

const mapTimeAttackRoundWeighting = (
  fsModel: FsTimeAttackRoundWeighting
): TimeAttackRoundWeighting | undefined => {
  if (
    !fsModel.startRoundNum ||
    !fsModel.order ||
    !isTimeAttackRoundWeightingOrder(fsModel.order) ||
    !fsModel.weightings
  ) {
    return undefined;
  }

  return {
    endRoundNum: fsModel.endRoundNum,
    startRoundNum: fsModel.startRoundNum,
    order: fsModel.order,
    weightings: nonUndefined(fsModel.weightings),
  };
};
